import { first } from "lodash";

export default {
    name: "ComsobaseCourseBlock",
    props: {
      isFirst: {
        type: Boolean,
        default: false,
      },
      course: {
        type: Object,
        default: () => {},
      }
    },
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {},
    methods: { first }
}
